import { configureStore } from '@reduxjs/toolkit'
import authReducer from './Slice/authSlice'
import requestTypeReducer from './Slice/requestTypeSlice'


export const Store = configureStore({
  reducer: {
    auth: authReducer,
    requestType: requestTypeReducer
  },
})